import { UiCommand, UiCommandEvent } from '@ui/cer-ui-types';
import { FieldWidthEnum } from 'src/cer/cer-data/cer-data-types';
import { ProductService } from '../product.service';
import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormView } from '@form/cer-form-view';
import { productNavigations } from './refdata-product.form';

const uiCmdProfitLossActivate: UiCommand = {
    id: 'uiCmdProfitLossActivate',
    text: 'Aktiver driftsføring',
    tooltipText: 'Aktiver at titel kan driftsføres',
    target: ".e-content",
    iconCss: "e-menu-icon e-icons-org e-changes-accept"
};

export class ProductFinanceStatusForm extends CerFormAdapter {

    override view(): CerFormView {
        const view = new CerFormView({

            viewMetadata: {
                name: 'titel-status', dataApiName: 'RefDataProductStatProduct', text: 'Titel rapportering',
                primaryKey: 'num', baseFields: ['id'], titleFields: ['productNum', 'name'],
                allowEdit: false, allowCreate: false, allowDelete: false,
                navigations: productNavigations
            },
            toolbarCommands: [uiCmdProfitLossActivate],
            onCommandEvent: ((e) => { this.onCommand(e) }),
            listSelectionMode: 'checkboxMulti',
            fieldMetadata: [
                { name: 'productNum', text: 'ISBN', widthType: FieldWidthEnum.XXL },
                { name: 'projectNum', text: 'Projekt', widthType: FieldWidthEnum.XXS },
                { name: 'contractNum', text: 'Kontrakt', widthType: FieldWidthEnum.XXS, visible: false },
                { name: 'projectItemNum', text: 'Varenr.', visible: false },
                { name: 'name', text: 'Titel', widthType: FieldWidthEnum.XXXL },
                { name: 'responsibleShortName', text: 'Redaktør', widthType: FieldWidthEnum.XXS, visible: false },
                { name: 'contributorAuthor', text: 'Forfatter', widthType: FieldWidthEnum.XS, visible: false },
                { name: 'group', text: 'Gruppe', widthType: FieldWidthEnum.XXS, visible: false },
                { name: 'type', text: 'Type', widthType: FieldWidthEnum.XXS },
                { name: 'contractType', text: 'Kontrakttype', widthType: FieldWidthEnum.XXS, visible: false },
                { name: 'contractSettlementType', text: 'Afregningstype', widthType: FieldWidthEnum.XXS, visible: false },
                { name: 'publishingDate', text: 'Udgivet dato', tooltipText: 'Udgivet dato fra Bogportalen', format: 'DateShort'},
                { name: 'publishedDays', text: 'Dage udgivet', tooltipText: 'Antal dage udgivet fra Bogportalen', format: 'Integer', visible: false },
                { name: 'isPublished', text: 'Er udgivet', tooltipText: 'Udgivet på Bogportalen', format: 'CheckBox' },
                { name: 'buyableTrade', text: 'Kan købes', tooltipText: 'Kan købes på Bogportalen', format: 'CheckBox', visible: false },
                { name: 'apologyCode', text: 'Undskyldningskode', format: 'NumberLeft', widthType: FieldWidthEnum.XS, visible: false },
                { name: 'onhandQtyPhysical', text: 'Fysisk lager', format: 'Number' },
                { name: 'onhandQtyAvailable', text: 'Disponibelt lager', format: 'Number', visible: false },
                { name: 'costPLReady', text: 'Driftsføres', format: 'CheckBox' },
                { name: "salesAmount", text: 'Omsætning', format: 'Amount' },
                { name: "salesQty", text: 'Oms. antal', format: 'Integer', visible: false },
                { name: "salesMaxDate", text: 'Oms. dato', format: 'DateShort', visible: false },
                { name: "costAmount", text: 'Omk.', format: 'Amount' },
                { name: "costMaxDate", text: 'Omk.dato', format: 'DateShort' },
                { name: "costAmountBalance", text: 'Igangværende', format: 'Amount0' },
                { name: "costAmountPL", text: 'Driftsført', format: 'Amount' },
                { name: "resultAmount", text: 'Bidrag', format: 'Amount' }
            ]
        });
        view.fieldMetadata.filter(f => f.text == null).forEach(f => {
            f.visible = false;
        });
        return view;
    }

    private onCommand(event: UiCommandEvent) {
        switch (event.commandId) {
            case uiCmdProfitLossActivate.id:
                this.onProfitLossActivateEvent(event);
                break;
        }
    }

    private onProfitLossActivateEvent(event: UiCommandEvent) {
        var ui = this.context.ui;
        var appComp = event.appComponent;

        var rowsData: any[] = event.rowsData;
        var productNums: string[] = [];

        var txt: string[] = ["Følgende titler kan driftsføres:"];
        rowsData?.forEach((p: any) => {
            if (p.productNum?.length > 0) {
                productNums.push(p.productNum)

                if (txt.length < 10) {
                    txt.push(' ' + p.productNum + ' / ' + (p.contractNum ?? "") + ': ' + (p.name ?? ""));
                }
                if (txt.length == 10) {
                    txt.push('.. (' + rowsData.length + ' titler)');
                }
            }
        });
        if (productNums.length == 0) {
            ui.error("Ingen titler markeret");
            return;
        }

        const productService: ProductService = this.context.injector.get(ProductService);
        productService.profitLossActivateInput(txt)
            .then(promptOk => {
                if (promptOk) {
                    productService.profitLossActivate(promptOk, productNums).subscribe({
                        next: count => {
                            ui.infoToast("Opdatering fuldført", count + " " + (count != 1 ? "titler" : "titel"));
                            if (count > 0) {
                                appComp.research();
                            }
                        },
                        error: error => {
                            ui.infoToast("Opdatering ikke fuldført");
                            ui.errorApi(error);
                        }
                    });
                }
            })
            .catch(error => {
                ui.errorApi(error);
            });
    }
}
